// types.ts
export type ISO8601 = string; // e.g. "2025-08-26T11:13:46.133Z"

export type FileRef = { id: string; url: string; type?: string; version?: string };
export type Appearance = { 
    appearanceinc: number;
    appearanceowner?: string;
    appearancesortorder?: number;
    appearancetitle?: string;
    sessioninc?: number
};
export type Session = {
    sessioninc: number;
    sessiontitle?: string;
    time_end?: number;
    time_start?: number;
    [k: string]: unknown;
};

export type SessionWithTimes = Session & Required<Pick<Session, "time_start" | "time_end">>;
export const isSessionWithTimes = (s: Session): s is SessionWithTimes => typeof s.time_start === "number" && typeof s.time_end === "number";
//export const normalizeSessions = (sessions: Session[]): SessionWithTimes[] => sessions.filter(isSessionWithTimes).sort((a, b) => a.time_start - b.time_start);

export type Agenda = {
  sessions: Session[];
  appearances?: Appearance[];
  files?: FileRef[];
  [k: string]: unknown; // allow extra fields from API
};

export type Settings = {
  background?: { url: string; version?: string };
  skin?: string | null;
  locale?: string;    // e.g. "sv-SE"
  timeZone?: string;  // IANA tz, e.g. "Europe/Stockholm"
  [k: string]: unknown;
};

export type ApiSnapshot = {
  settings: Settings;
  agenda: Agenda;
  version?: string | number;

  // <-- all top-level
  agendaTitle?: string;
  label?: string;
  timestamp?: string; // ISO string
  requestTime?: number; // ISO string
  requestTimeISO?: ISO8601; // ISO string

};

export type HeaderInfo = {
  agendaTitle?: string;
  label?: string;
  timestamp?: string;
};

export type UIMetaDay = "TODAY" | "TOMORROW" | "NONE";

export interface UIMeta {
  day: UIMetaDay;
  message?: string;
}

export interface UIState {
  /** High-level hints for skins (empty-state, badges, etc.) */
  meta?: UIMeta;
  /** Room for skin-specific flags without widening SkinContext */
  [k: string]: unknown;
}

export type SkinContext = {
  container: HTMLElement;
  settings: Settings;
  agenda: Agenda;
  requestTime?: number;
  requestTimeISO?: ISO8601;
  header: HeaderInfo;
  config?: {
    locale?: string;
    timeZone?: string;
    [k: string]: unknown;
  };
  vm?: { 
    sessionsByDay?: Record<string, Session[]>;
    nowISO?: string,
    requestTime?: number;
    requestTimeISO?: ISO8601;
  };
  ui?: UIState;
};

export interface SkinElement extends HTMLElement {
  context: SkinContext;  // readable + writable
}

export interface SkinModule {
  define(): void;
  mount(ctx: SkinContext): SkinElement;
  update(root: SkinElement, ctx: SkinContext): void;   // ← add root
  unmount?(root: SkinElement): void;
}